var exports = {
  "kL": "xfd349460--e1ce6d--container",
  "hr": "xfd349460--e1ce6d--inner_container",
  "AS": "xfd349460--e1ce6d--item",
  "PN": "xfd349460--e1ce6d--item--reviews",
};

module.exports = exports;
